<template>
  <!-- 企业 -->
  <div class="enterprise-floor floor-item">
    <div class="enterprise-wrap">
      <div class="headline">
        <div class="head-title">企业</div>
        <ul class="entype">
          <li
            v-for="(type, index) in enTypeList"
            :key="index"
            :class="[activeIndex === index ? 'actived' : '']"
            @click="handleEnTypeClick(index, type)"
          >
            {{ type }}
          </li>
        </ul>
        <div class="address">
          <span>地区：</span>
          <check-address
            :region="regionList"
            @checked="handleAddress"
          ></check-address>
        </div>
        <div class="more" @click="lookMoreData">
          查看更多 >>>
        </div>
      </div>
      <div class="contain">
        <ul class="enterprise-list">
          <li v-for="(item, index) in enterpriseList" :key="index">
            <div class="point"></div>
            <p class="entname" @click="praiseDetail(item)">
              {{ handleOverflow(item.entName) }}
            </p>
            <set-rate :value="item.averageScore" disable></set-rate>
            <p class="city">
              <span>{{ handleAddr(item.province, item.city) }}</span>
            </p>
            <div class="contact">
              <span class="phone">{{ item.linkmanMobile }}</span>
              <span v-if="!isLogin" class="look-btn" @click="toLogin">
                点击查看
              </span>
            </div>
          </li>
        </ul>
        <div class="praise-wrap">
          <div class="title">
            <img src="../imgs/rank.png" alt="" /> 好评排行榜
          </div>
          <ul class="rank-list">
            <li
              v-for="item in praiseEnterprise"
              :key="item.entGuid"
              @click="praiseDetail(item)"
            >
              <div class="num">
                {{ item.entGuid }}
              </div>
              <div class="title">{{ item.entName }}</div>
              <div :class="['rank-up', item.type === 'up' ? 'red' : 'green']">
                <img v-if="item.type === 'up'" src="../imgs/up.png" alt="" />
                <img v-else src="../imgs/down.png" alt="" />
                {{ item.rank }}
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $axios from 'axios'

import { mapState } from 'vuex'
import checkAddress from '../../../components/checkAddress.vue'
import setRate from './setRate'
const newEnterprise = [
  {
    entGuid: 1,
    entName: '中建科工集团有限公司',
    type: 'up',
    rank: 1
  },
  {
    entGuid: 2,
    entName: '杭萧钢构股份有限公司',
    type: 'down',
    rank: 1
  },
  {
    entGuid: 3,
    entName: '江苏沪宁钢机股份有限公司',
    type: 'up',
    rank: 2
  },
  {
    entGuid: 4,
    entName: '上海宝冶集团有限公司',
    type: 'up',
    rank: 3
  },
  {
    entGuid: 5,
    entName: '江苏苏博特新材料股份有限公司',
    type: 'down',
    rank: 1
  },
  {
    entGuid: 6,
    entName: '智迈德股份有限公司',
    type: 'up',
    rank: 7
  },
  {
    entGuid: 7,
    entName: '天津友发钢管集团股份有限公司',
    type: 'up',
    rank: 3
  },
  {
    entGuid: 8,
    entName: '海蒂诗五金配件(上海)有限公司',
    type: 'up',
    rank: 2
  }
]
const typeList = [
  '全部',
  '生产加工',
  '销售贸易',
  '建筑设备',
  '建筑设计',
  '地产开发',
  '施工安装'
]
export default {
  components: {
    checkAddress,
    setRate
  },
  data() {
    return {
      praiseEnterprise: newEnterprise,
      form: {
        pageNum: 0,
        pageSize: 8,
        citys: [],
        province: [],
        secondlabelNames: [],
        sortFlag: 0
      },
      enTypeList: typeList,
      activeIndex: 0,
      regionList: []
    }
  },
  computed: {
    ...mapState({
      isLogin: state => state.login.isLogin,
      citys: state => state.enterprise.citys,
      province: state => state.enterprise.province,
      enterpriseList: state => state.enterprise.enterpriseList
    })
  },
  watch: {
    isLogin() {
      if (!this.isLogin) {
        this.queryEnterpriseList()
      }
    }
  },
  created() {
    this.form.citys = this.citys
    this.form.province = this.province
    if (/(iPhone|iPad|iPod|iOS|Android)/i.test(navigator.userAgent)) {
      this.queryEnterpriseList()
    } else {
      this.getLocation()
    }
  },
  methods: {
    // 高德获取当前定位
    async getLocation() {
      await $axios({
        url: `https://restapi.amap.com/v3/ip?key=8ea487e17a4482fa950999109ba88305&ip=${returnCitySN.cip}`,
        method: 'get'
      })
        .then(res => {
          if (res.data.status === '1') {
            this.form.province = [res.data.province]
            this.regionList = this.form.province
            this.queryEnterpriseList()
          } else {
            this.queryEnterpriseList()
          }
        })
        .catch(() => {
          this.queryEnterpriseList()
        })
    },
    // 地区
    handleAddress() {
      this.form.province = this.province
      this.form.citys = this.citys
      this.queryEnterpriseList()
    },
    // 查询企业列表
    queryEnterpriseList() {
      this.$store.dispatch('enterprise/queryEnterpriseList', this.form)
    },
    //  点击标签类型
    handleEnTypeClick(index, type) {
      this.activeIndex = index
      this.form.secondlabelNames = [type]
      if (type === '全部') {
        this.form.secondlabelNames = []
      }
      this.$store.commit(
        'enterprise/SET_SECOND_LABEL_NAMES',
        this.form.secondlabelNames
      )
      this.queryEnterpriseList()
    },
    // 查看更多
    lookMoreData() {
      this.$store.commit('enterprise/SET_IS_PRE_MATCH', false)
      this.$store.commit('search/SET_SEARCH_TEXT', '')
      this.$router.push({
        path: '/enterpriseList'
      })
    },
    handleAddr(province, city) {
      if (province === '-') province = ''
      if (city === '-') city = ''
      let address = ''
      if (province === city) {
        address = city
      } else {
        address = `${province} ${city}`
      }
      return address
    },
    //  好评榜详情
    praiseDetail(enterprise) {
      this.$store.commit('search/SET_SEARCH_TEXT', enterprise.entName)
      this.$store.commit('enterprise/SET_IS_PRE_MATCH', true)
      this.$store.commit('enterprise/SET_CITYS', [])
      this.$store.commit('enterprise/SET_PROVINCE', [])
      this.$store.commit('enterprise/SET_REGION_LIST', [])
      this.$store.commit('enterprise/SET_SECOND_LABEL_NAMES', [])
      this.$router.push({
        path: '/enterpriseList'
      })
    },
    // 点击查看(用户未登录的情况下显示)
    toLogin() {
      this.$store.dispatch('login/login')
    },
    // 超出处理
    handleOverflow(str) {
      let new_str = ''
      new_str = str
      if (str && str.length > 20) {
        new_str = str.substr(0, 19) + '...'
      }
      return new_str
    }
  }
}
</script>

<style lang="scss" scoped>
// 企业
.enterprise-floor {
  width: 1200px;
  margin: 0 auto;
  padding-top: 40px;
  .enterprise-wrap {
    height: 518px;
    background-image: url('../imgs/enterprise-bg.png');
    background-position: center;
    background-size: contain;
    background-repeat: no-repeat;
    padding: 0 20px;
    .headline {
      height: 64px;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      .head-title {
        font-size: 25px;
        font-weight: bold;
        color: #333333;
        line-height: 36px;
        margin-right: 60px;
      }
      ul.entype {
        display: flex;
        align-items: center;
        font-size: 15px;
        color: #333333;
        line-height: 21px;
        li {
          cursor: pointer;
          margin-left: 30px;
        }
        li:first {
          margin-left: 100px;
        }
        .actived {
          color: #d01c26;
          font-weight: bold;
          position: relative;
          &::after {
            content: '';
            position: absolute;
            bottom: -8px;
            left: 50%;
            transform: translateX(-50%);
            width: 10px;
            height: 2px;
            background: #d01c26;
            border-radius: 2px;
          }
        }
      }
      .address {
        font-size: 15px;
        color: #666666;
        line-height: 21px;
        margin-left: 70px;
        display: flex;
        align-items: center;
      }
      .more {
        font-size: 12px;
        color: #d01c26;
        line-height: 17px;
        cursor: pointer;
        margin-left: 135px;
      }
    }
    .contain {
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      ul.enterprise-list {
        width: 100%;
        display: flex;
        justify-content: flex-start;
        align-items: flex-start;
        flex-wrap: wrap;
        flex: 1;
        li {
          width: 200px;
          height: 200px;
          background: #ffffff;
          box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.13);
          border-radius: 4px;
          margin-bottom: 20px;
          padding: 18px 20px;
          margin-right: 20px;
          .point {
            width: 12px;
            height: 12px;
            background: #f2f5fc;
            margin-left: -4px;
            box-shadow: 0px 1px 3px 0px rgba(0, 0, 0, 0.13);
          }
          .entname {
            height: 50px;
            font-size: 16px;
            font-weight: bold;
            color: #333333;
            line-height: 22px;
            margin: 15px 0 0 0;
            font-family: '微软雅黑';
            cursor: pointer;
            &:hover {
              color: #d01c26;
            }
          }
          .city {
            margin-top: 14px;
            span {
              padding: 2px 5px;
              background: #7377b8;
              border-radius: 2px;
              font-size: 10px;
              font-weight: bold;
              color: #ffffff;
              // max-width: 150px;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
            }
          }
          .contact {
            margin-top: 12px;
            .phone {
              font-size: 12px;
              color: #333333;
              line-height: 17px;
            }
            .look-btn {
              cursor: pointer;
              font-size: 12px;
              color: #3c95ff;
              line-height: 17px;
              margin-left: 10px;
            }
          }
        }
      }

      .praise-wrap {
        width: 278px;
        height: 420px;
        background: #ffffff;
        border-radius: 2px;
        padding: 20px 18px 0;
        .title {
          font-size: 16px;
          font-weight: bold;
          color: #333333;
          line-height: 22px;
          display: flex;
          align-items: center;

          img {
            width: 19px;
            height: auto;
            margin-right: 5px;
          }
        }
        ul.rank-list {
          margin-top: 10px;
          li {
            height: 45px;
            display: flex;
            align-items: center;
            justify-content: flex-start;
            position: relative;
            cursor: pointer;
            .num {
              width: 18px;
              height: 18px;
              display: flex;
              justify-content: center;
              align-items: center;
              font-size: 10px;
              font-weight: bold;
              line-height: 15px;
              color: #bfbfbf;
              background-position: left;
              background-size: contain;
              background-repeat: no-repeat;
              margin-right: 6px;
              padding-left: 1px;
            }
            .title {
              width: 193px;
              font-size: 14px;
              color: #666666;
              line-height: 21px;
              flex: 1;
              display: block;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
              &:hover {
                color: #d01c26;
              }
            }
            .rank-up {
              display: flex;
              align-items: center;
              font-size: 10px;
              line-height: 14px;
              img {
                width: 6px;
                height: 8px;
                margin-right: 2px;
              }
              .green {
                color: #65b977;
              }
              .red {
                color: #d01c26;
              }
            }
          }
          li::after {
            content: '';
            position: absolute;
            right: 0;
            bottom: 0;
            width: 218px;
            height: 1px;
            background: #efefef;
          }
          li:last-child::after {
            content: '';
            position: absolute;
            right: 0;
            bottom: 0;
            width: 218px;
            height: 1px;
            background: #ffffff;
          }
          li:first-child .num {
            color: #ffffff;
            background-image: url('../imgs/first.png');
          }
          li:nth-child(2) .num {
            color: #ffffff;
            background-image: url('../imgs/second.png');
          }
          li:nth-child(3) .num {
            color: #ffffff;
            background-image: url('../imgs/third.png');
          }
        }
      }
    }
  }
}
</style>
